<div class="container mt-3 mx-auto">
  <div
    class="alert alert-info"
    *ngIf="!detalhesLeilao || !detalhesLeilao.length"
  >
    Não foram encontradas leilões com os filtros informados.
  </div>

  <div *ngIf="detalhesLeilao && detalhesLeilao.length">

    <bn-paginacao
      [total]="atributosPaginacao.count"
      [tamanhoPagina]="atributosPaginacao.pageSize"
      [numPagina]="atributosPaginacao.page"
      [opcoesTamanhoPagina]="opcoesPaginacao"
      (aoMudar)="mudancaPagina($event)"
    >
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th id="col-agente" scope="col">
                <bn-ordenacao
                  [ordenacao]="atributosOrdenacao"
                  [atributo]="'id'"
                  [nomeAtributoExibicao]="'ID leilão'"
                  (aoClickar)="mudancaOrdenacao($event)"
                >
                </bn-ordenacao>
              </th>
              <th *ngIf="!ehAgenteFinanceiro" id="col-agente" scope="col">
                <bn-ordenacao
                  [ordenacao]="atributosOrdenacao"
                  [atributo]="'cnpjAgenteFinanceiro'"
                  [nomeAtributoExibicao]="'Agente financeiro'"
                  (aoClickar)="mudancaOrdenacao($event)"
                >
                </bn-ordenacao>
              </th>
              <th id="col-data-envio" scope="col">
                <bn-ordenacao
                  [ordenacao]="atributosOrdenacao"
                  [atributo]="'dataEnvio'"
                  [nomeAtributoExibicao]="'Data de envio'"
                  ngbTooltip="Data do envio das informações de leilão ao FG2"
                  (aoClickar)="mudancaOrdenacao($event)"
                >
                </bn-ordenacao>
              </th>
              <th id="col-data-leilao" scope="col">
                <bn-ordenacao
                  [ordenacao]="atributosOrdenacao"
                  [atributo]="'dataLeilao'"
                  [nomeAtributoExibicao]="'Data leilão'"
                  ngbTooltip="Data da realização do leilão informada pelo AF"
                  (aoClickar)="mudancaOrdenacao($event)"
                >
                </bn-ordenacao>
              </th>
              <th id="col-data-recuperacao" scope="col">
                <bn-ordenacao
                  [ordenacao]="atributosOrdenacao"
                  [atributo]="'dataRecebimentoValorArrematado'"
                  [nomeAtributoExibicao]="'Data recebimento'"
                  ngbTooltip="Data do recebimento do valor arrematado no leilão"
                  (aoClickar)="mudancaOrdenacao($event)"
                >
                </bn-ordenacao>
              </th>
              <th id="col-nome-valorRecuperacao" scope="col" class="moeda">
                <bn-ordenacao
                  [ordenacao]="atributosOrdenacao"
                  [atributo]="'valorRecuperadoLeilao'"
                  [nomeAtributoExibicao]="'Valor total arrematado'"
                  ngbTooltip="Valor total arrematado do lote leiloado informado pelo AF"
                  (aoClickar)="mudancaOrdenacao($event)"
                >
                </bn-ordenacao>
              </th>
              <th id="col-estado" scope="col">
                <bn-ordenacao
                  [ordenacao]="atributosOrdenacao"
                  [atributo]="'estado.nomeEstado'"
                  [nomeAtributoExibicao]="'Estado'"
                  (aoClickar)="mudancaOrdenacao($event)"
                >
                </bn-ordenacao>
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container
              *ngFor="let detalheLeilao of detalhesLeilao; let i = index"
            >
              <tr [routerLink]="['/leilao/detalhe', detalheLeilao.idLeilao]">
                <td>{{ detalheLeilao.idLeilao }}</td>
                <td>
                  {{ nomeAgente(detalheLeilao.cnpjAgenteFinanceiro) }}
                </td>
                <td>
                  {{ detalheLeilao.dataEnvio | date : "dd/MM/yyyy HH:mm" }}
                </td>
                <td>
                  {{ detalheLeilao.dataRealizacao | date : "dd/MM/yyyy" }}
                </td>
                <td>
                  {{ detalheLeilao.dataRecebimentoValorArrematado| date : "dd/MM/yyyy" }}
                </td>
                <td class="moeda">
                  {{ detalheLeilao.valorRecuperadoLeilao | bnMask : "MOEDA" }}
                </td>
                <td>{{ detalheLeilao.estado?.nomeEstado }}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </bn-paginacao>
  </div>
</div>
